<template>
  <div>
    <CCallout color="primary">
      <h6 class="text-primary">{{ info.title }}</h6>
      <p class="text-break">{{ info.description }}</p>
      <div class="preview-img" @click="enlargeImg = !enlargeImg">
        <CImage
          v-if="info.image"
          rounded
          thumbnail
          :src="info.image"
          width="200"
          height="200"
          class="mb-4"
        />
        <img
          v-if="info.image"
          class="enlarge"
          src="@/assets/icons/enlarge.svg"
          alt=""
        />
      </div>
      <EnLargeImg :show="enlargeImg" :image="info.image" />
    </CCallout>
  </div>
</template>

<script>
import EnLargeImg from '@/components/QuestionnaireContent/EnLargeImg.vue'
import { ref } from '@vue/reactivity'
import { onMounted } from '@vue/runtime-core'

export default {
  components: {
    EnLargeImg,
  },
  props: {
    info: {
      type: Object,
      default: () => {},
    },
  },
  emits: ['content'],
  setup(props, { emit }) {
    const enlargeImg = ref(false)
    const emitContent = () => {
      emit('content', {
        part_item_id: props.info.part_item_id,
        type: props.info.type,
        value_info: props.info.title,
      })
    }
    onMounted(() => {
      emitContent()
    })
    return {
      emitContent,
      enlargeImg,
    }
  },
}
</script>
<style lang="scss" scoped>
.enlarge {
  width: 20px;
  position: absolute;
  right: 5px;
  bottom: 30px;
}
.preview-img {
  width: 200px;
  position: relative;
}
</style>
